import { Link } from "react-router-dom";
import { useAuth } from "../../Services/AuthContext";
import "./HamburgerMenu.css";
import {
  AudioLines,
  LayoutDashboard,
  CircleUserRound,
  SlidersHorizontal,
  LogOut,
  Binoculars,
  Radio,
  X,
} from "lucide-react";
import DefaultAvatar from "../DefaultAvatar";
import GoingOutStatusControl from "../GoingOut/GoingOutStatusControl";

type HamburgerMenuProps = {
  name: string;
  isActive: boolean;
  onClose: () => void;
};

export default function HamburgerMenu({name, isActive, onClose }: HamburgerMenuProps) {
  const { user, logout } = useAuth();

  const isContributor =
    user?.role === "CONTRIBUTOR" ||
    user?.role === "ADMIN" ||
    user?.role === "SUPERADMIN";

  const isAdmin = user?.role === "ADMIN" || user?.role === "SUPERADMIN";

  const handleLogout = () => {
    logout();
    onClose();
  };

  return (
    <div className={`hamburger-wrapper ${isActive ? "active" : ""}`}>
 
      <span className="hamburger-close-icon" style={{color: 'white', fontSize: '2rem'}}>
        <X size={32} strokeWidth={1.9} onClick={onClose}/>
        </span>
    
     <div className="hamburger-user">
        <DefaultAvatar name={name} />
        <div className="hamburger-user-column">
          <span className="hamburger-user-text">Can you feel it?</span>
          <span className="hamburger-user-name">{name}</span>
        </div>
    </div>

        {/* Samma sak som i dropdownen på desktop: kartan har slutat
            fråga, och det här är stället att ändra sig på. Menyn stängs
            inte av ett svar — man kan hinna ångra sig två gånger. */}
        <GoingOutStatusControl variant="menu" />

        <nav className="hamburger-items">
                    <Link className="menu-item" to="/" onClick={onClose}>
                    <Binoculars size={20} strokeWidth={1.9} />
            Explore
          </Link>
          <Link className="menu-item" to="/feed" onClick={onClose}>
            <Radio size={20} strokeWidth={1.9} />
            Feed
          </Link>
          <Link className="menu-item" to={`/profile/${user?.id}`} onClick={onClose}>
          <CircleUserRound size={20} strokeWidth={1.9} />
            Profile
          </Link>


          {isContributor && (
            <Link className="menu-item" to="/recognize" onClick={onClose}>
              <AudioLines size={20} strokeWidth={1.9} />
              Recognize
            </Link>
          )}

          {isAdmin && (
            <Link className="menu-item" to="/administrazione" onClick={onClose}>
              <LayoutDashboard size={20} strokeWidth={1.9} />
              Dashboard
            </Link>
          )}

          <Link className="menu-item" to="/settings" onClick={onClose}>
          <SlidersHorizontal size={20} strokeWidth={1.9} />
            Settings
          </Link>


      </nav>
              <button className="logout-button" type="button" onClick={handleLogout}>
                <LogOut size={18} strokeWidth={1.9} />
          Log out
        </button>
    </div>
  );
}